// extracted by mini-css-extract-plugin
export var container = "view-module--container--1c649";
export var nonav = "view-module--nonav--47ef3";
export var noplayer = "view-module--noplayer--184c0";